module.exports = __webpack_public_path__ + "static/media/wmgr_manager_future_lg.b5cc40e2.png";